<template>
  <Base
    ref="base"
    :on-submit="(params) => projectsService.createFormTemplate(params)"
    :triger-prevent="trigerPrevent"
    field-details-route="content-field-details"
    templates-route="content-templates"
    :show-teams="false"
    :is-one="true"
    group-name="Main Topic"
  />
</template>

<script>
import { mapActions } from 'vuex';
import Base from '../base/base';

import { ProjectsMixin } from '../../../../../mixins';

import { beforeRouteLeaveFunction } from '../base/common';

export default {
  title: 'NewCaseTempalte',
  components: { Base },
  mixins: [ProjectsMixin],
  beforeRouteLeave(to, from, next) {
    const changed = this.$refs.base.exit();
    return beforeRouteLeaveFunction(to, from, next, this.disablePrevent, this.$translate, changed, this.clearTemplates);
  },
  data() {
    return {
      disablePrevent: false,
    };
  },
  ...mapActions({ clearTemplates: 'template/clearTemplates' }),
  methods: {
    trigerPrevent: function (value) {
      this.disablePrevent = value;
    },
  },
};
</script>
